const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://landingpagecreatorbackend.azurewebsites.net/api';

export const assetsAPI = {
  list: async (websiteId, scope = 'site') => {
    const response = await fetch(
      `${API_BASE_URL}/websites/${websiteId}/assets?scope=${encodeURIComponent(scope)}`
    );
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || 'Failed to load images');
    }
    return response.json();
  },

  upload: async (websiteId, file, scope = 'site') => {
    const form = new FormData();
    form.append('file', file);
    const response = await fetch(
      `${API_BASE_URL}/websites/${websiteId}/assets?scope=${encodeURIComponent(scope)}`,
      {
        method: 'POST',
        body: form,
      }
    );
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || 'Failed to upload image');
    }
    return response.json();
  },
};
